<mat-nav-list>
  <a
    class="nav-item"
    mat-menu-item
    [routerLink]="link.path"
    routerLinkActive="active"
    [queryParams]="link.query"
    *ngFor="let link of navList"
    (click)="onClose()"
  >
    <mat-icon>{{ link.icon }}</mat-icon>
    <span class="nav-text">{{ link.name }}</span>
  </a>
</mat-nav-list>
